// extracted by mini-css-extract-plugin
module.exports = {"ellipsisLoader":"_1L5-I","ellipsisScale":"_1kUN4","ellipsisMovement":"f0twa","ellipsisScaleReverse":"jBNgs"};